<template>
  <v-card v-if="showCbteAsociado()" elevation="1" class="mb-4">
    <v-card-text>
      <h6 class="text-h6 black--text">Comprobante asociado</h6>
      <p class="text-body-2">Ingrese los datos del comprobante asociado al que intenta generar</p>

      <v-row>
        <v-col md="3">
          <v-combobox
            v-model="comprobante_asociado.cbte_tipo"
            data-vv-as="Tipo de comprobante asociado"
            name="cbte_tipo_asoc"
            item-text="Desc"
            item-value="Id"
            :items="cbte_tipos_invoice"
            label="Tipo de comprobante"
            autocomplete="off"
            class="overflow-auto"
            filled
            clearable
            v-validate="'combobox'"
            @change="$emit('searchCbteAsociado')"
            :disabled="invoice_to_cancel != null || invoice.id > 0"
          ></v-combobox>
          <span class="red--text">{{ errors.first("cbte_tipo_asoc") }}</span>
        </v-col>
        <v-col md="3" class="mt-2">
          <v-text-field
            autocomplete="off"
            data-vv-as="Punto de venta"
            label="Punto de venta"
            name="pto_vta_asoc"
            v-validate="'integer'"
            clearable
            v-model="comprobante_asociado.pto_vta"
            @change="$emit('searchCbteAsociado')"
            :disabled="invoice_to_cancel != null || invoice.id > 0"
          >
          </v-text-field>
          <span class="red--text">{{ errors.first("pto_vta_asoc") }}</span>
        </v-col>
        <v-col md="3" class="mt-2">
          <v-text-field
            autocomplete="off"
            data-vv-as="Nº de factura"
            label="Nº de factura"
            name="num_voucher"
            v-validate="'integer'"
            v-model="comprobante_asociado.voucher_number"
            @change="$emit('searchCbteAsociado')"
            :disabled="invoice_to_cancel != null || invoice.id > 0"
          >
            <v-icon v-if="invoice.cbte_asoc != null" slot="append" color="green"> mdi-check </v-icon>
            <v-icon v-if="comprobante_asociado.voucher_number != '' && comprobante_asociado.voucher_numbe != null && invoice.cbte_asoc == '' && !loading_voucher_asociado" slot="append" color="red">
              mdi-close
            </v-icon>
          </v-text-field>
          <span class="red--text">{{ errors.first("num_voucher") }}</span>
        </v-col>
        <v-col md="3" v-if="vouchersService.isElectronicVoucher(comprobante_asociado.cbte_tipo)">
          <v-combobox
            :disabled="invoice_to_cancel != null || invoice.id > 0"
            v-model="comprobante_asociado.anulacion"
            data-vv-as="Motivo"
            name="anulacion"
            item-text="name"
            item-value="id"
            v-validate="'combobox'"
            :items="[
              { id: 'N', name: 'Anulación' },
              { id: 'S', name: 'Rechazo' },
            ]"
            label="Motivo"
            autocomplete="off"
            class="overflow-auto"
            filled
            clearable
          ></v-combobox>
          <span class="red--text">{{ errors.first("anulacion") }}</span>
        </v-col>
        <v-col md="3" v-else></v-col>
        <v-col v-if="showMessageNotFound()" md="12">
          <div>
            <span style="color: red">No se encontro el comprobante ingresado</span>
          </div>
        </v-col>
        <v-col v-if="loading_voucher_asociado" md="12">
          <div>
            <span color="blue-grey">Buscando comprobante...</span>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
import { billingGeneralService } from "@/libs/ws/billingGeneralService";
import { vouchersService } from "@/libs/ws/vouchersService";
export default {
  created() {
    this.$validator = this.validator;
  },
  components: {},
  props: {
    invoice: Object,
    invoice_to_cancel: Object,
    loading_combos: Object,
    comprobante_asociado: Object,
    loading_voucher_asociado: Boolean,
    error_search_cbte_asociado: Boolean,
    searchCbteAsociado: Function,
    validator: Object,
  },
  data: () => ({
    cbte_tipos_invoice: [],
    emitter_selected: null,
    vouchersService: vouchersService,
  }),
  watch: {
    invoice: {
      handler: function (newValue) {
        if (newValue == null) {
          return;
        }
        if ((this.emitter_selected == null && newValue.emitter != null) || (newValue.emitter != null && this.emitter_selected.id != newValue.emitter.id)) {
          this.emitter_selected = newValue.emitter;
          this.getCbtesTipos();
          //al cambiar el emisor se cambia el tipo de comprobante de datos generales reseteo cbe asociado
          //solo hace esto si no venis con un comprobate a cancelar desde facturacion
          if (this.invoice_to_cancel == null) {
            this.comprobante_asociado.cbte_tipo = null;
            this.comprobante_asociado.pto_vta = null;
            this.comprobante_asociado.voucher_number = null;
            this.comprobante_asociado.anulacion = null;
            this.errors.clear();
            this.validator.reset();
          }
        }
      },
      deep: true,
    },
  },
  mounted() {},
  methods: {
    getCbtesTipos() {
      if (this.invoice.emitter != null && this.invoice.emitter.id > 0) {
        this.loading_combos["cbte_tipos_invoice"] = true;
        //Se Pide para saber si el comprobante seleccionado a emitir requiere comprobantes asociados (No es factura)
        billingGeneralService.cbteTiposInvoice(this.invoice.emitter.id).then((response) => {
          if (response.status) {
            this.cbte_tipos_invoice = response.result;
            this.loading_combos["cbte_tipos_invoice"] = false;

            /*
            if (this.invoice_to_cancel != null) {
              this.cbte_tipo_asoc = this.$emit("selectComboId", this.cbte_tipos_invoice, this.invoice_to_cancel.cbte_tipo, "Id");
            }
            */
          }
        });
      }
    },
    showCbteAsociado() {
      if (this.invoice == null || (this.invoice != null && this.invoice.cbte_tipo == null)) {
        return false;
      }
      return !vouchersService.VoucherList().includes(this.invoice.cbte_tipo.Id);
    },
    showMessageNotFound() {
      return !this.loading_voucher_asociado && this.error_search_cbte_asociado;
    },
  },
};
</script>
